import chroma from 'chroma-js'

// iOS
export const iOSSystemTintsLightPink = '#FF2D55'
export const iOSSystemTintsLightBlue = '#007AFF'

// Custom
export const feature = '#5B5E63'
export const focus = '#909397'
export const common = '#A8B1B9'
export const trivial = '#BCC3CA'
export const subtle = '#DDE0E3'
export const clear = '#FEFEFE'
export const black = '#000000'
export const white = '#FFFFFF'

// System
export const error = '#E45353'
export const errorTransparent = '#F5BDBD'
export const success = '#44D887'

//SR
export const srGreen = "#8DC63F"
export const srGreenTransparent = 'rgba(126, 188, 86, 0.1)'
export const dialBlue = '#0091FF'
export const srDarkGreen = '#195820'
export const srPlaceholder = '#959595'
export const srTextInput = '#1E1E1E'
export const srGreyBackground = '#E5E5E5'

//Biker Mobile
export const jetBlack = '#000000'
export const darkCharcoal = '#1F1F1F'
export const brightOrange = '#FF6A00'
export const softGray = '#CCCCCC'

//My Charity Mobile
export const textDark = '#336AA2'
export const textLight = '#63ACD9'
export const myCharityPink = '#A53061'

